import { konsole } from '@/utils/debug';

export const logKeyDown = (e: KeyboardEvent) => {
  konsole.log('Key:', e.code, 'Time:', new Date());
};
